var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { body } from "../../../typography";
import { bonfireGet } from "../../../theme";
export var TextFieldWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  * {\n    box-sizing: border-box;\n  }\n"])));
export var RequiredMessage = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  font-style: italic;\n  padding-left: 5px;\n"], ["\n  ", ";\n  color: ", ";\n  font-style: italic;\n  padding-left: 5px;\n"])), body, function (_a) {
    var $hasError = _a.$hasError;
    return $hasError
        ? bonfireGet("colors", "validationDanger")
        : bonfireGet("colors", "textDark");
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map